/* ============================================================================
   MCS predictive search - ported from Prestige Truck's personal theme.

   Self-contained: it reads its configuration from window.MCSSearchConfig, which
   sections/static-header.liquid writes, rather than from a theme-wide `theme`
   global that Empire does not provide.

   It drives the header search on its own. Empire's own LiveSearch is not
   involved, because the header renders the field WITHOUT the data-live-search*
   hooks Empire binds to - two predictive searches on one input would each
   overwrite the other's flydown.
   ========================================================================= */
(function () {
  'use strict';

  var cfg = window.MCSSearchConfig || {};

  /* SYN-CORE-START */
  /* ---------- SEARCH SYNONYMS (2026-10-13) - shared core ----------
     Source of truth: setup/scripts/pt-search/syn-core.js (tests: syn-core.test.mjs). The patch scripts copy this
     block verbatim into PT assets/theme.js and MCS assets/mcs-search.js between the SYN-CORE markers.

     Data: shop metafield search_tools.synonyms = {v: 1, groups: [["head", "two way", "~one way"], ...]}.
       - the FIRST entry is the head: the catalogue's own wording, used to rewrite a query and in the
         "Showing results for" note;
       - a plain entry is TWO-WAY: typing any of them matches products titled with any plain entry;
       - a "~" entry is ONE-WAY (misspellings, run-together brand names): it only ever leads to the head.
     makeSyn(data).expand(terms) -> {
       words:     the typed words no group claimed (matched one by one, as before),
       slots:     one per matched entry: {alts: [[word, ...], ...]} - ANY alt matching satisfies the slot,
       rewritten: the query with every matched entry replaced by its head ('' when nothing changed),
       note:      {from, to, oneWay} for the first matched entry that is not a head, else null }
     Normalising: lower case, hyphens removed (so f-150 = f150, the same rule as the grid's matcher),
     anything else that is not a letter, digit or & becomes a space. ES5 so it runs in every file. */
  function makeSyn(data) {
    var groups = (data && data.groups) || [];
    var norm = function (s) {
      return String(s == null ? '' : s).toLowerCase().replace(/-/g, '').replace(/[^a-z0-9&]+/g, ' ').replace(/\s+/g, ' ').trim();
    };
    var entries = [], heads = [], plain = [];
    groups.forEach(function (g, gi) {
      if (!g || !g.length) return;
      var headRaw = String(g[0]).replace(/^~/, ''), seen = {};
      /* q = the head as it is written in the catalogue (hyphens kept: "f-150" ranks better than "f150") */
      heads[gi] = { raw: headRaw, n: norm(headRaw), q: headRaw.toLowerCase().replace(/[^a-z0-9&-]+/g, ' ').replace(/\s+/g, ' ').trim() };
      plain[gi] = [];
      g.forEach(function (e, ei) {
        var raw = String(e), one = ei > 0 && raw.charAt(0) === '~', n;
        raw = raw.replace(/^~/, '');
        n = norm(raw);
        if (!n || seen[n]) return;
        seen[n] = 1;
        entries.push({ n: n, t: n.split(' '), g: gi, one: one, head: ei === 0, raw: raw });
        if (!one) plain[gi].push(n);
      });
    });
    /* one word equals another, or its plural (s / es): "nerf bar" and "nerf bars" are the same entry */
    var same = function (a, b) {
      return a === b || (a.length > 2 && b.length > 2 && (a + 's' === b || b + 's' === a || a + 'es' === b || b + 'es' === a));
    };
    /* longest first, so "truck bed cover" wins over "bed cover" and "cover" */
    entries.sort(function (a, b) { return b.t.length - a.t.length || b.n.length - a.n.length; });
    /* the typed words twice over: as typed (hyphens kept, for the rewritten query) and normalised (for matching) */
    function tokens(terms) {
      var raw = String(terms == null ? '' : terms).toLowerCase().replace(/[^a-z0-9&-]+/g, ' ').trim().split(' '), out = { raw: [], n: [] };
      raw.forEach(function (w) { var n = w.replace(/-/g, ''); if (n) { out.raw.push(w); out.n.push(n); } });
      return out;
    }
    function expand(terms) {
      var tk = tokens(terms), toks = tk.n, used = toks.map(function () { return 0; }), hits = [];
      entries.forEach(function (e) {
        for (var i = 0; i + e.t.length <= toks.length; i++) {
          var ok = true, k;
          for (k = 0; k < e.t.length; k++) if (used[i + k] || !same(toks[i + k], e.t[k])) { ok = false; break; }
          if (!ok) continue;
          for (k = 0; k < e.t.length; k++) used[i + k] = 1;
          hits.push({ at: i, len: e.t.length, e: e });
        }
      });
      hits.sort(function (a, b) { return a.at - b.at; });
      var words = toks.filter(function (w, i) { return !used[i]; });
      var slots = hits.map(function (h) {
        var e = h.e, alts = e.one ? [heads[e.g].n, e.n] : plain[e.g].slice();
        return { alts: alts.filter(function (a, i) { return alts.indexOf(a) === i; }).map(function (a) { return a.split(' '); }) };
      });
      var out = [], j = 0, changed = false, note = null;
      hits.forEach(function (h) {
        for (; j < h.at; j++) out.push(tk.raw[j]);
        out.push(heads[h.e.g].q);
        if (!h.e.head) {
          changed = true;
          if (!note) note = { from: h.e.raw, to: heads[h.e.g].raw, oneWay: h.e.one };
        }
        j = h.at + h.len;
      });
      for (; j < toks.length; j++) out.push(tk.raw[j]);
      return { words: words, slots: slots, rewritten: changed ? out.join(' ') : '', note: note };
    }
    return { expand: expand, norm: norm, size: entries.length };
  }
  /* SYN-CORE-END */
  var syn = cfg.synonyms ? makeSyn(cfg.synonyms) : null;
  var predictivePanel = null;
  var predictiveInput = null;
  var predictiveStatus = null;
  var predictiveIdleHTML = '';
  var predictiveController = null;
  var predictiveSeq = 0;
  var predictiveActive = -1;
  var predictiveTypedTerm = '';

  var SEARCH_RECENT_KEY = 'mcs:recent-searches';
  var RECENT_MAX = 5;

  /* Repeat queries are common (backspacing, retyping). The endpoint sends no
     Cache-Control at all, so the browser will not cache for us. Capped and
     time-limited so it cannot serve stale prices after an inventory change. */
  var predictiveCache = new Map();
  var CACHE_MAX = 50;
  var CACHE_TTL = 5 * 60 * 1000;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function cacheGet(key) {
    var hit = predictiveCache.get(key);
    if (!hit) return null;
    if (Date.now() - hit.at > CACHE_TTL) { predictiveCache.delete(key); return null; }
    // Refresh recency for LRU eviction.
    predictiveCache.delete(key);
    predictiveCache.set(key, hit);
    return hit.html;
  }

  function cacheSet(key, html) {
    predictiveCache.set(key, { html: html, at: Date.now() });
    if (predictiveCache.size > CACHE_MAX) {
      predictiveCache.delete(predictiveCache.keys().next().value);
    }
  }

  /* --- Recent searches (this browser only, never sent anywhere) --- */

  function readRecent() {
    try {
      var raw = window.localStorage.getItem(SEARCH_RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      // Only ever render strings, so a browser holding older malformed data
      // cannot show "[object Object]" chips forever.
      return list.filter(function (t) { return typeof t === 'string' && t.trim(); });
    } catch (e) { return []; }
  }

  function pushRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    try {
      var list = readRecent().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      list.unshift(term);
      window.localStorage.setItem(SEARCH_RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) { /* private mode, quota - not worth surfacing */ }
  }

  function renderRecent() {
    if (!predictivePanel) return;
    var wrap = predictivePanel.querySelector('[data-search-recent]');
    var list = predictivePanel.querySelector('[data-search-recent-list]');
    if (!wrap || !list) return;
    var items = readRecent();
    if (!items.length) { wrap.hidden = true; list.innerHTML = ''; return; }
    var html = '';
    items.forEach(function (term, i) {
      html += '<li><a class="search-panel__chip" role="option" aria-selected="false"' +
        ' id="search-opt-recent-' + i + '" tabindex="-1" data-search-option' +
        ' data-search-term="' + escapeHtml(term) + '"' +
        ' href="' + cfg.searchUrl + '?q=' + encodeURIComponent(term) + '">' +
        escapeHtml(term) + '</a></li>';
    });
    list.innerHTML = html;
    wrap.hidden = false;
  }

  /* --- Panel state --- */

  function predictiveOptions() {
    return predictivePanel ? Array.prototype.slice.call(
      predictivePanel.querySelectorAll('[data-search-option]')
    ) : [];
  }

  function setActive(index) {
    var opts = predictiveOptions();
    opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); o.classList.remove('is-active'); });
    predictiveActive = index;
    if (index < 0 || index >= opts.length) {
      if (predictiveInput) predictiveInput.setAttribute('aria-activedescendant', '');
      return;
    }
    var el = opts[index];
    el.setAttribute('aria-selected', 'true');
    el.classList.add('is-active');
    if (predictiveInput) predictiveInput.setAttribute('aria-activedescendant', el.id || '');
    // Without this, arrowing walks into options below the fold.
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    // Copy the term into the field so autocomplete works as a query BUILDER,
    // not just a submit shortcut - the shopper can arrow to "reformer" and
    // keep typing " with tower".
    var term = el.getAttribute('data-search-term');
    if (term && predictiveInput) predictiveInput.value = term;
  }

  function openPredictive() {
    if (!predictivePanel) return;
    predictivePanel.hidden = false;
    if (predictiveInput) predictiveInput.setAttribute('aria-expanded', 'true');
  }

  function closePredictive() {
    predictiveSeq += 1;
    if (predictiveController) { predictiveController.abort(); predictiveController = null; }
    if (predictivePanel) predictivePanel.hidden = true;
    if (predictiveInput) {
      predictiveInput.setAttribute('aria-expanded', 'false');
      predictiveInput.setAttribute('aria-activedescendant', '');
    }
    predictiveActive = -1;
  }

  function setPanelHTML(html) {
    if (!predictivePanel) return;
    predictivePanel.innerHTML = html;
    predictiveActive = -1;
    if (predictiveInput) predictiveInput.setAttribute('aria-activedescendant', '');
  }

  function showIdle() {
    setPanelHTML(predictiveIdleHTML);
    renderRecent();
    var hasAnything = predictivePanel && predictivePanel.querySelector('[data-search-option]');
    if (hasAnything) { openPredictive(); } else { closePredictive(); }
  }

  function announceResults(terms) {
    if (!predictiveStatus) return;
    var opts = predictiveOptions().length;
    predictiveStatus.textContent = opts
      ? opts + ' results for ' + terms
      : 'No results found for ' + terms;
  }

  function init() {
    var wrap = document.querySelector('[data-header-search]');
    if (!wrap) return;
    predictiveInput = wrap.querySelector('[data-search-input]');
    predictivePanel = wrap.querySelector('[data-search-suggest]');
    predictiveStatus = wrap.querySelector('[data-search-status]');
    if (!predictiveInput || !predictivePanel) return;

    var idleTemplate = wrap.querySelector('[data-search-idle-template]');
    predictiveIdleHTML = idleTemplate ? idleTemplate.innerHTML : predictivePanel.innerHTML;

    var minChars = parseInt(cfg.minChars, 10);
    if (isNaN(minChars) || minChars < 1) minChars = 1;

    function fetchFor(terms) {
      var cached = cacheGet(terms);
      if (cached != null) { setPanelHTML(cached); openPredictive(); announceResults(terms); return; }

      // Abort the previous request AND guard on a sequence number. The abort
      // alone leaves a window where a slower earlier response is already in the
      // network stack and would overwrite newer results.
      if (predictiveController) predictiveController.abort();
      predictiveController = new AbortController();
      var seq = ++predictiveSeq;

      // limit_scope=each is essential: the default caps the whole response at
      // 10 results ACROSS all types, so products crowd out everything else.
      var url = cfg.predictiveUrl +
        '?q=' + encodeURIComponent(terms) +
        '&resources[type]=query,product,collection,page' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=mcs-predictive-search';

      var signal = predictiveController.signal;
      var panelFor = function (u) {
        return fetch(u, { signal: signal })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (text) { return new DOMParser().parseFromString(text, 'text/html').querySelector('[data-search-panel-inner]'); });
      };
      /* SEARCH SYNONYMS 2026-10-13: nothing for the words typed, but a synonym knows the catalogue's own word:
         ONE more request, shown under a "Showing results for" line. Searches that find products never pay for it.
         Real product results only - a search with none still carries the "Try these" fallback rows. */
      var alt = syn ? syn.expand(terms).rewritten : '';
      var hasProducts = function (node) {
        return !!node && !!node.querySelector('[aria-labelledby="SearchProductLabel"] a.search-panel__product');
      };

      panelFor(url)
        .then(function (inner) {
          if (seq !== predictiveSeq || !alt || hasProducts(inner)) return inner;
          return panelFor(url.replace('?q=' + encodeURIComponent(terms) + '&', '?q=' + encodeURIComponent(alt) + '&')).then(function (inner2) {
            if (!hasProducts(inner2)) return inner;
            var g = document.createElement('div'), p = document.createElement('p'), b = document.createElement('strong');
            g.className = 'search-panel__group';
            p.className = 'search-panel__none search-panel__note';
            b.textContent = alt;
            p.appendChild(document.createTextNode('Showing results for '));
            p.appendChild(b);
            g.appendChild(p);
            inner2.insertBefore(g, inner2.firstChild);
            return inner2;
          }, function () { return inner; });
        })
        .then(function (inner) {
          if (seq !== predictiveSeq) return;
          var html = inner ? inner.outerHTML : '';
          cacheSet(terms, html);
          setPanelHTML(html);
          openPredictive();
          announceResults(terms);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          // Never strand the shopper on a network blip - fall back to the idle
          // panel rather than an empty box.
          if (seq === predictiveSeq) showIdle();
        });
    }

    var debouncedFetch = debounce(function (terms) { fetchFor(terms); }, 200);

    predictiveInput.addEventListener('input', function () {
      var terms = predictiveInput.value.trim();
      predictiveTypedTerm = terms;
      if (terms.length < minChars) {
        if (predictiveController) { predictiveController.abort(); predictiveController = null; }
        predictiveSeq += 1;
        showIdle();
        return;
      }
      debouncedFetch(terms);
    });

    predictiveInput.addEventListener('focus', function () {
      var terms = predictiveInput.value.trim();
      if (terms.length >= minChars) { fetchFor(terms); } else { showIdle(); }
    });

    predictiveInput.addEventListener('keydown', function (e) {
      var opts = predictiveOptions();
      var open = !predictivePanel.hidden && opts.length > 0;

      if (e.key === 'ArrowDown') {
        if (!open) { showIdle(); return; }
        e.preventDefault();
        setActive(predictiveActive + 1 >= opts.length ? 0 : predictiveActive + 1);
      } else if (e.key === 'ArrowUp') {
        if (!open) return;
        e.preventDefault();
        if (predictiveActive <= 0) {
          // Back to the field with whatever they actually typed restored.
          setActive(-1);
          predictiveInput.value = predictiveTypedTerm;
        } else {
          setActive(predictiveActive - 1);
        }
      } else if (e.key === 'Home' && open) {
        e.preventDefault(); setActive(0);
      } else if (e.key === 'End' && open) {
        e.preventDefault(); setActive(opts.length - 1);
      } else if (e.key === 'Enter') {
        if (open && predictiveActive >= 0) {
          e.preventDefault();
          pushRecent(predictiveInput.value.trim());
          window.location.href = opts[predictiveActive].getAttribute('href');
        } else {
          pushRecent(predictiveInput.value.trim());
        }
      } else if (e.key === 'Escape') {
        // First press closes and keeps the text; a second clears the field.
        if (!predictivePanel.hidden) {
          e.preventDefault();
          closePredictive();
        } else if (predictiveInput.value) {
          e.preventDefault();
          predictiveInput.value = '';
          predictiveTypedTerm = '';
          showIdle();
        }
      }
    });

    // Delegated so it survives every panel swap.
    predictivePanel.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      var fill = e.target.closest('[data-search-fill]');
      if (fill) {
        // Build on the suggestion instead of submitting it.
        e.preventDefault();
        e.stopPropagation();
        predictiveInput.value = fill.getAttribute('data-search-fill');
        predictiveTypedTerm = predictiveInput.value;
        predictiveInput.focus();
        fetchFor(predictiveInput.value.trim());
        return;
      }

      if (e.target.closest('[data-search-clear-recent]')) {
        e.preventDefault();
        try { window.localStorage.removeItem(SEARCH_RECENT_KEY); } catch (err) {}
        renderRecent();
        return;
      }

      var opt = e.target.closest('[data-search-option]');
      if (opt) pushRecent(predictiveInput.value.trim());
    });

    var form = predictiveInput.form;
    if (form) {
      form.addEventListener('submit', function () {
        pushRecent(predictiveInput.value.trim());
      });
    }

    /* --- Outside click / Escape, and the mobile reveal ------------------- */

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      // Empire renders a magnifier button instead of the bar below its S
      // breakpoint. It reveals this bar in place rather than opening Empire's
      // takeover, which no longer has a flydown to fill.
      var toggle = e.target.closest('[data-mobile-search-button]');
      if (toggle) {
        e.preventDefault();
        var open = document.body.classList.toggle('mcs-search-open');
        if (open) {
          window.setTimeout(function () { predictiveInput.focus(); }, 60);
        } else {
          closePredictive();
        }
        return;
      }

      if (!e.target.closest('[data-header-search]')) closePredictive();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (predictivePanel && !predictivePanel.hidden) closePredictive();
    });
  }

  /* SEARCH SYNONYMS 2026-10-13: the results page. A search that found NOTHING reloads once with the catalogue's
     word (?sq= keeps what was typed, so it never loops); the reloaded page says what it searched for instead.
     static-search.liquid holds a zero-result page invisible (html.mcs-syn-wait, 1.5 s cap) while this decides. */
  function searchPage() {
    var html = document.documentElement, meta = document.querySelector('[data-mcs-search-meta]');
    var release = function () { html.classList.remove('mcs-syn-wait'); };
    if (!meta) return release();
    var u = new URL(window.location.href), q = u.searchParams.get('q') || '', sq = u.searchParams.get('sq');
    var terms = meta.getAttribute('data-terms') || '', count = parseInt(meta.getAttribute('data-count'), 10) || 0, r;
    if (sq) {
      if (count > 0) {
        var host = document.querySelector('.productgrid--outer'), p = document.createElement('p'), b = document.createElement('strong');
        p.className = 'mcs-search-note';
        b.textContent = terms;
        p.appendChild(document.createTextNode('Showing results for '));
        p.appendChild(b);
        p.appendChild(document.createTextNode('. No results for \u201c' + sq + '\u201d.'));
        if (host) host.insertBefore(p, host.firstChild);   /* inside: it carries the page gutter */
      }
      return release();
    }
    if (count > 0 || !syn || !terms || q.indexOf(':') >= 0) return release();
    r = syn.expand(terms);
    if (!r.rewritten) return release();
    u.searchParams.set('q', r.rewritten);
    u.searchParams.set('sq', terms);
    u.searchParams.delete('page');
    window.location.replace(u.toString());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); searchPage(); });
  } else {
    init();
    searchPage();
  }
})();
